<template>
  <component
    :is="componentName"
    v-bind="$attrs"
  />
</template>

<script>

import AuthNPoliciesAsidePanel from 'client/Security/AuthNPoliciesAsidePanel/AuthNPoliciesAsidePanel.vue';
import AuthNPoliciesAsidePanelLegacy from 'client/Security/AuthNPoliciesAsidePanel/AuthNPoliciesAsidePanelLegacy.vue';
// This component exists to support both updated & legacy Conditional Access aside
// and legacy aside while there is a feature flag
export default {
  name: 'AuthNPoliciesAsidePanelWrapper',

  components: {
    AuthNPoliciesAsidePanelLegacy,
    AuthNPoliciesAsidePanel,
  },

  computed: {
    componentName() {
      return this.showNewPanel ? 'AuthNPoliciesAsidePanel' : 'AuthNPoliciesAsidePanelLegacy';
    },
    showNewPanel() {
      return this.$hasFeatureFlag(this.$featureFlags.conditionalAccessAsideUpdate);
    },
  },
};
</script>
